import { v4 as uuidv4 } from "uuid";

export const challenges = [
    {
      arcId: uuidv4(),
      name: "Mini Saitama Workout",
      category: "Fitness",
      timePeriod: "7",
      habits: [
        "Complete 10 Push ups 💪",
        "Complete 10 Sit ups 🧘‍♂️",
        "Complete 10 Squats 🏋️‍♂️"
      ]
    },
    {
      arcId: uuidv4(),
      name: "Social Butterfly Challenge",
      category: "Socializing",
      timePeriod: "7",
      habits: [
        "Talk to one new person 🦋",
        "Complement your friend 👫"
      ]
    },
    {
      arcId: uuidv4(),
      name: "Chill Out and Relax",
      category: "Mental Wellness",
      timePeriod: "14",
      habits: [
        "Practice 15 minutes of meditation 🧘",
        "Take deep breaths for relaxation 😌",
        "Spend time outdoors to connect with nature 🌳"
      ]
    },
    {
      arcId: uuidv4(),
      name: "Attitude of Gratitude",
      category: "Personal Development",
      timePeriod: "21",
      habits: [
        "Write down 3 things you're grateful for 🙏",
      ]
    },
    {
      arcId: uuidv4(),
      name: "Daily Personal Brand Boost",
      category: "Personal Branding",
      timePeriod: "30",
      habits: [
        "Post 3 Tweets related to your expertise 🐦",
        "Engage with 2 industry influencers 👥",
      ]
    },
    {
      arcId: uuidv4(),
      name: "30 Days of Code",
      category: "Programming",
      timePeriod: "100",
      habits: [
        "Code for at least 1 hour every day ⏰",
        "Document your progress on social media 📝",
      ]
    },
    {
      arcId: uuidv4(),
      name: "21 Days of DSA",
      category: "Programming",
      timePeriod: "21",
      habits: [
        "Share your progress on Twitter 📰",
        "Solve 2 coding problems daily 💻",
      ]
    },
    {
      arcId: uuidv4(),
      name: "30 Days of Twitter",
      category: "Social Media",
      timePeriod: "30",
      habits: [
        "Tweet daily about your thoughts or progress 🐦",
        "Engage with at least 2 followers by responding to tweets 💬",
      ]
    }
    // Add more challenges as needed
  ];
